import React, { useContext, useMemo } from "react";
import { StyleSheet, View } from "react-native";
import { useI18n } from "../../hooks/i18n-hooks";
import VStack from "../../ui_atoms/VStack";
import Text from "../../components/Text";
import { ProfileSwitcherManagerContext } from "../../contexts/ProfileSwitcherManager";
import { useIntercom } from "../../hooks/intercom";
import { useStatusBarTranslucent } from "../../hooks/use-status-bar-translucent";
import { LiftPerson } from "../../components/LiftPerson";
import ScreenCard from "../ScreenCard";
import { kycGradient } from "../../configs/linear-gradients";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Loading from "../../components/Loading";

const IdVerificationPending = () => {
    const i18n = useI18n();
    const { openProfileSwitch, profileIds } = useContext(ProfileSwitcherManagerContext);
    const { presentIntercom } = useIntercom();
    const insets = useSafeAreaInsets();
    const styles = useStyles();

    const hasMultipleProfiles = useMemo(() => profileIds.length > 1, [profileIds.length]);

    useStatusBarTranslucent();

    return (
        <ScreenCard
            backgroundGradient={kycGradient}
            buttons={[
                hasMultipleProfiles
                    ? {
                          title: i18n.t("pendingVerification.change_profile"),
                          onPress: openProfileSwitch,
                          mode: "secondary",
                      }
                    : {
                          title: i18n.t("assistance"),
                          onPress: () => {
                              void presentIntercom();
                          },
                          size: "medium",
                          mode: "primary",
                      },
            ]}
            contentStyle={{
                paddingTop: insets.top,
                paddingBottom: 0,
            }}
            scrollEnabled={false}
            isContentContainerFlex
        >
            <VStack v={1} h={1} style={{ flex: 1 }}>
                <LiftPerson
                    markdownProps={{
                        markdown: i18n.t("screens.auth.idVerificationPending.description"),
                    }}
                />
                <View style={styles.loaderContainer}>
                    <Loading />
                </View>
            </VStack>
        </ScreenCard>
    );
};

const useStyles = () => {
    return useMemo(
        () =>
            StyleSheet.create({
                loaderContainer: {
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                },
            }),
        [],
    );
};

export default IdVerificationPending;
